import React from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface MomentControlProps {
  index: number;
  count: number;
  title: string;
  onPrev: () => void;
  onNext: () => void;
}
const screens = [{
  to: '/',
  label: 'Wand'
}, {
  to: '/bureau',
  label: 'Bureau'
}, {
  to: '/spec',
  label: 'Spec'
}];

/** Demo control: click through the scenario and switch screens. Sits apart from the product UI. */
export function MomentControl({
  index,
  count,
  title,
  onPrev,
  onNext
}: MomentControlProps) {
  return <div className="absolute left-1/2 top-2 z-40 flex -translate-x-1/2 items-center gap-1 rounded-full border border-white/10 bg-night-900 p-0.5" data-id="element-1442" data-mp="31qxlp4cfqj16">
      <nav aria-label="Demo-schermen" className="flex items-center border-r border-white/10 pr-1" data-id="element-1443" data-mp="3bnsd73aajj5y">
        {screens.map(s => <NavLink key={s.to} to={s.to} end className={({
        isActive
      }) => `whitespace-nowrap rounded-full px-3 py-2 text-[14px] font-medium transition-colors duration-150 ${isActive ? 'bg-white/[0.08] text-ink' : 'text-ink-muted hover:text-ink'}`} data-id="element-1444" data-mp="1lce2a88ajwxs">
            {s.label}
          </NavLink>)}
      </nav>
      <button type="button" onClick={onPrev} aria-label="Vorig moment" className="grid h-9 w-9 place-items-center rounded-full text-ink-muted transition-colors duration-150 hover:text-ink" data-id="element-1445" data-mp="1h0fhobr4ahsz">
        <ChevronLeftIcon className="h-5 w-5" data-id="element-1446" data-mp="1q0cckv43ocwh" />
      </button>
      <span className="whitespace-nowrap px-1 text-[14px] tabular-nums text-ink-muted" data-id="element-1447" data-mp="1v0gsok13j5m6">
        {index + 1}/{count} · {title}
      </span>
      <button type="button" onClick={onNext} className="flex h-9 items-center gap-1 whitespace-nowrap rounded-full pl-2 pr-3 text-[14px] font-medium text-ink transition-colors duration-150 hover:text-accent" data-id="element-1448" data-mp="1zyie3blzvh0t">
        Volgende moment <ChevronRightIcon className="h-4 w-4" aria-hidden data-id="element-1449" data-mp="3tq8nrtheope9" />
      </button>
    </div>;
}